import { render, staticRenderFns } from "./BiographyComponentLayout.vue?vue&type=template&id=1018ba38&scoped=true&"
import script from "./BiographyComponentLayout.vue?vue&type=script&lang=js&"
export * from "./BiographyComponentLayout.vue?vue&type=script&lang=js&"
import style0 from "./BiographyComponentLayout.vue?vue&type=style&index=0&id=1018ba38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1018ba38",
  null
  
)

component.options.__file = "BiographyComponentLayout.vue"
export default component.exports